const monthNames = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
const monthNamesShort = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
const dayNames = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
const dayNamesShort = ['日', '一', '二', '三', '四', '五', '六']

const formatDate = (y, m, d, format = 'yyyy-mm-dd') => {
    const date = new Date(Number(y),Number(m) -1,Number(d))
    const year = date.getFullYear()
    const month = date.getMonth()
    const month1 = month + 1
    const day = date.getDate()
    const weekDay = date.getDay()
    return format
        .replace(/yyyy/g, year)
        .replace(/yy/g, (year + '').substring(2))
        .replace(/mm/g, month1 < 10 ? '0' + month1 : month1)
        .replace(/m/g, month1)
        .replace(/MM/g, monthNames[month])
        .replace(/M/g, monthNamesShort[month])
        .replace(/dd/g, day < 10 ? '0' + day : day)
        .replace(/d/g, day)
        .replace(/DD/g, dayNames[weekDay])
        .replace(/D/g, dayNamesShort[weekDay])
}

// 格式化时分秒
const Format = (d,fmt) => {
    const date = new Date(d)
    let o = {
        "M+": date.getMonth() + 1, //月份 
        "d+": date.getDate(), //日 
        "H+": date.getHours(), //小时 
        "m+": date.getMinutes(), //分 
        "s+": date.getSeconds(), //秒 
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
        "S": date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length))
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
    return fmt
}
const getDistanceDays = (startDate, endDate) =>{ //获取两个日期相差天数 startDate和endDate是yyyy-MM-dd格式
    let startDateArray = startDate.split('-')
    let endDateArray = endDate.split('-')
    let start = new Date(Number(startDateArray[0]), Number(startDateArray[1]) + 1, Number(startDateArray[2]))
    let end = new Date(Number(endDateArray[0]), Number(endDateArray[1]) + 1, Number(endDateArray[2]))
    let times = end.getTime() - start.getTime()
    let days = parseInt(times / (1000 * 60 * 60 * 24)) + 1
  　return days
}

const getLastWeek = ( now = true, format = 'yyyy-mm-dd') =>{//now 是否包含今天
    let end = new Date()
    let start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
    let newStart = now ? formatDate(start.getFullYear(), start.getMonth() + 1, start.getDate(), format) : formatDate(start.getFullYear(), start.getMonth() + 1, start.getDate() -1, format)
    let newEnd = now ? formatDate(end.getFullYear(), end.getMonth() + 1, end.getDate(), format) :  formatDate(end.getFullYear(), end.getMonth() + 1, end.getDate() - 1, format)
    return [newStart, newEnd]
}

export {
    formatDate,
    getDistanceDays,
    getLastWeek,
    Format
}

export default {
    formatDate,
    getDistanceDays,
    getLastWeek,
    Format
}



// WEBPACK FOOTER //
// ./src/utils/date.js